module.exports = __webpack_public_path__ + "media/images/game/categories/pece_o_sebe-9c703cf57dfb79c896c741e65c15f618.png";